import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import Loading from "../Layout/Loading";
import EntryFormContent from "./EntryFormContent";
import { addNewEntry } from "../../actions/CustomerVisitAction";
import { getUserDetailsForApplicationSale } from "../../services/applicationReport";
import { getDistributorNames, getUserId } from "../../Common/functions";

const AddNewEntry = ({ closeModal: parentCloseModal, userRole }) => {
  const modalRef = useRef(null);
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [formData, setFormData] = useState({
    visitdate: new Date().toISOString().split("T")[0],
    doctorsname: "",
    call_notes: "",
    product_discussed: "",
  });
  const [loading, setLoading] = useState(false);
  const [userProfileDetails, setUserProfileDetails] = useState({});

  // Check if the screen is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 748); // Same breakpoint as sm in Tailwind //FIXME:
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  const closeModal = () => {
    setIsOpen(false);
    setTimeout(() => {
      parentCloseModal();
    }, 400);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const generateTimestamp = () => {
    const date = new Date();

    const pad = (n) => n.toString().padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are 0-based
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const getUserProfileDetails = async () => {
    let result = [];
    result = await getUserDetailsForApplicationSale(
      // {"Distributor_Name":formData.Distributor_Name?formData.Distributor_Name :distributorsList[0]}
      {
        category:
          userRole === "super_admin" || userRole === "application_specialist"
            ? "user-profile"
            : userRole === "distributor_admin"
            ? "distributor-admin-profile"
            : "Internal-user-profile",
        UserId: getUserId(),
      }
    );
    console.log("re", result);
    setUserProfileDetails(result?.data[0]);
  };
  useEffect(() => {
    getUserProfileDetails();
  }, []);

  // Prepare data for submission
  const prepareSubmissionData = () => {
    const timestampUnique = generateTimestamp();

    const data = {
      ...formData,
      // Add required fields based on jQuery logic
      UserId: getUserId(), // You'll need to get this from your app context
      username: userProfileDetails.username || "", // You'll need to get this from your app context
      timestamp: "",
      category: "customer visit",
      group_title: userProfileDetails.GroupName || "", // You'll need to get this from your app context
      team: userProfileDetails.team || "", // You'll need to get this from your app context
      assigner: userProfileDetails.assignername || "", // You'll need to get this from your app context
      // nickname: userProfileDetails.nickname, // You'll need to get this from your app context
      // managerID: "manager_id_here", // You'll need to get this from your app context
      // sales_order_status: "Pending",
      // Name: timestampUnique,
      // doctors_name: formData.doctorsname,
      distributor_name: getDistributorNames()[0],
    };
    return data;
  };

  // Submit to sales tracking
  const submitToSalesTracking = async (data) => {
    try {
      const response = await fetch(
        "https://46zd64zt92.execute-api.us-east-2.amazonaws.com/Prod/sales_tracking_distributorsales_post",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      return await response.json();
    } catch (error) {
      console.error("Error submitting to sales tracking:", error);
      throw error;
    }
  };

  const handleSubmit = async () => {
    console.log("formData", formData);
    if (
      !formData.doctorsname ||
      !formData.call_notes ||
      !formData.product_discussed
    ) {
      toast.error("Please fill all required fields.");
      return;
    }

    const submissionData = prepareSubmissionData();
    console.log("Submission data:", submissionData);
    setLoading(true);
    try {
      const response = await submitToSalesTracking(submissionData);
      console.log(response);
      // if (response.success) {
      // toast.success("Successfully added");
      //   closeModal();
      // } else {
      //   toast.error("Error occurred");
      // }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <AnimatePresence>
        {isOpen &&
          (isMobile ? (
            // Mobile dialog (centered, no animation)
            <div
              ref={modalRef}
              className="bg-white w-[90%] max-w-md rounded-lg max-h-[75vh] overflow-y-auto px-6 shadow-lg h-5/6"
            >
              {loading ? (
                <Loading />
              ) : (
                <>
                  <EntryFormContent
                    formData={formData}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    handleCancel={parentCloseModal}
                  />
                </>
              )}
            </div>
          ) : (
            // Desktop slide-in panel
            <motion.div
              ref={modalRef}
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "tween", duration: 0.4 }}
              className="bg-white  w-[70vw] h-full px-6 absolute right-0 top-0 shadow-lg max-w-[900px]"
            >
              {loading ? (
                <Loading />
              ) : (
                <>
                  <button
                    onClick={closeModal}
                    className="absolute top-0 -left-12 bg-gray-200 rounded-md p-1 shadow-md"
                  >
                    <X className="w-7 h-7 text-gray-500 hover:text-gray-800" />
                  </button>
                  <div className="pt-4">
                    <EntryFormContent
                      formData={formData}
                      handleChange={handleChange}
                      handleSubmit={handleSubmit}
                    />
                  </div>
                </>
              )}
            </motion.div>
          ))}
      </AnimatePresence>
    </div>
  );
};

export default AddNewEntry;
